import React from 'react'
import { Field } from 'redux-form'
import { FAIcon } from './FAIcon'
import { FormBox } from './FormBox'
import { TagsBox } from './TagsBox'
import { DebounceInput } from './DelayInput/DelayInput'
import styles from './DataGridSearch.less'
import { pt } from 'common-data/proptypehelpers'

const SEARCH_INPUT_STYLE = {
  border: 'none',
  outline: 'none',
  boxShadow: 'none',
  background: 'transparent',
  padding: 0,
  width: '100%',
  fontSize: 14,
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  color: 'inherit'
}

const SearchInputField = ({ input, meta, placeholder }) => (
  <DebounceInput
    style={SEARCH_INPUT_STYLE}
    minLength={0}
    delayTimeout={300}
    type='text'
    placeholder={placeholder}
    onChange={(e) => input.onChange(e.target.value)}
    value={input.value || ''}
  />
)

export class DataGridSearch extends React.Component {
  static propTypes = {
    formName: pt.string.isRequired,
    onSubmit: pt.func.isRequired,
    onChange: pt.func,
    formInputType: pt.string.isRequired,
    fieldName: pt.string.isRequired,
    icon: pt.string.isRequired,
    loading: pt.bool.isRequired,
    promptText: pt.string,
    initialValues: pt.object,
    classNames: pt.shape({
      search: pt.string,
      searchForm: pt.string,
      searchIcon: pt.string
    }),
    hide: pt.bool.isRequired,
    autoDestoryForm: pt.bool.isRequired
  }

  static defaultProps = {
    classNames: {},
    hide: false,
    icon: 'search',
    loading: false,
    fieldName: 'Text',
    onSubmit: () => {},
    autoDestoryForm: false,
    formInputType: 'Tags' // Tags or Auto
  }

  render () {
    const { formName, onSubmit, fieldName, classNames, hide, icon, loading, promptText, autoDestoryForm, onChange, formInputType, initialValues } = this.props

    if (hide === true) {
      return null
    }

    return (
      <div className={classNames.search || styles.search}>
        <div className={classNames.searchIcon || styles.searchIcon}>
          <FAIcon name={icon || 'search'} />
        </div>
        <FormBox onChange={onChange} destroyOnUnmount={autoDestoryForm} simpleBody className={classNames.searchForm || styles.searchForm} form={formName} loading={loading} onSubmit={onSubmit} initialValues={initialValues}>
          {formInputType === 'Tags'
            ? <TagsBox name={fieldName} noLayout placeHolder={promptText} />
            : <Field name={fieldName} component={SearchInputField} placeholder={promptText} />
          }
        </FormBox>
      </div>
    )
  }
}
